import { atom } from "recoil";

export const brandLicensesStore = atom({
	key: "brandLicensesStore",
	default: {
		loaded: false,
		data: [],
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		currentOption: {
			status: false,
		},
		currentSearch: "",
		sorting: {
			sortingColumn: {
				order: "DESC",
				column: "id",
			},
			isDescending: true,
		},
		pagination: {
			current: 1,
			total: 0,
			count: 0,
		},
	},
});
